import React from 'react';
import SecondaryButton from '../UtilComponents/SecondaryButton';

import CapIcon from '../../CapIcon';

import CapColumn from '../../CapColumn';
import CapRow from '../../CapRow';
import CapSkeleton from '../../CapSkeleton';
import { Tooltip } from '../UtilComponents/Tooltip';
import classnames from 'classnames';

import { clsPrefix } from './constants';

// users message in chat
export const PromptLI = ({
  content,
  moreLikeThis,
  showReset,
  reset = () => {},
  textMoreLikeThis,
  textResetToDefault,
  ...rest
}) => {
  return (
    <ChatLI
      txt={
        <>
          <span style={{ fontWeight: '500' }}>
            {moreLikeThis && `${textMoreLikeThis}: `}
          </span>
          {content.originalMessage}
        </>
      }
      contentLength={content.originalMessage.length}
      emoji={content.originalSentimentEmoji}
      emojiTip={content.originalSentimentDescription}
      iconName="aira-user-chat"
      {...rest}
    >
      {showReset && (
        <div className={`${clsPrefix}-reset-to-default`} onClick={reset}>
          {textResetToDefault}
        </div>
      )}
    </ChatLI>
  );
};

// bot's suggestion in chat
export const SuggestionLI = ({
  content,
  replace = () => {},
  moreLikeThis = () => {},
  active,
  textReplaceWithThis,
  textMoreLikeThis,
  textReplaced,
  loading,
  ...rest
}) => {
  if (loading) {
    return (
      <div style={{ padding: '1rem' }}>
        <CapSkeleton
          loading={loading}
          active={true}
          avatar={true}
          paragraph={{ rows: 2 }}
          title={false}
        />
      </div>
    );
  }
  return (
    <ChatLI
      txt={content.content}
      emoji={content.modifiedSentimentEmoji}
      emojiTip={content.modifiedSentimentDescription}
      iconName="aira-bot-chat"
      data-active={active}
      {...rest}
    >
      <SecondaryButton
        className={classnames(
          `${clsPrefix}-only-hover`,
          `${clsPrefix}-more-btn`,
        )}
        iconName="heart-plus"
        text={textMoreLikeThis}
        onClick={moreLikeThis}
      />
      {active ? (
        <CapRow
          type="flex"
          align="middle"
          className={`${clsPrefix}-replaced-txt`}
        >
          <CapIcon type="check-filled" size="s" />
          <span>{textReplaced}</span>
        </CapRow>
      ) : (
        <SecondaryButton
          className={classnames(
            `${clsPrefix}-only-hover`,
            `${clsPrefix}-replace-btn`,
          )}
          iconName="swap"
          text={textReplaceWithThis}
          onClick={replace}
        />
      )}
    </ChatLI>
  );
};

// common code for any chat message
export const ChatLI = ({
  txt,
  emoji,
  emojiTip,
  iconName,
  children,
  contentLength,
  textCharacters,
  ...rest
}) => {
  return (
    <CapRow
      className={`${clsPrefix}-suggestion-li`}
      type="flex"
      align="top"
      {...rest}
    >
      <CapIcon type={iconName} className={`${clsPrefix}-chat-icon`} />
      <CapColumn className={`${clsPrefix}-content`}>
        <CapRow className={`${clsPrefix}-content-text`}>{txt}</CapRow>
        <CapRow
          type="flex"
          align="middle"
          className={`${clsPrefix}-content-info`}
        >
          <Tooltip title={emojiTip} placement="bottom">
            <span
              className={`${clsPrefix}-emoji`}
              style={{ fontSize: '1.1rem' }}
            >
              {emoji}
            </span>
          </Tooltip>
          <span className={`${clsPrefix}-emoji-character-count`}>
            {contentLength || txt.length} {textCharacters}
          </span>
          {children}
        </CapRow>
      </CapColumn>

      <div className={`${clsPrefix}-cover`} />
    </CapRow>
  );
};
